import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { setAnalyticsUser } from "../analytics";

/**
 * Keeps GA4's user identity in step with Auth0 (EB-558).
 *
 * Gated on `isLoading` because the answer is genuinely unknown until Auth0 has resolved, and
 * guessing "anonymous" in the meantime would be worse than waiting: a logged-in shopper on a cold
 * load would be reported as anonymous and then corrected, and GA does not retro-tag the events sent
 * in between.
 *
 * `user?.sub` rather than the whole `user` object in the dependency list — Auth0 hands back a new
 * object identity on every token refresh, and the identity has not changed just because the token
 * did.
 */
const useAnalyticsUser = () => {
  const { isLoading, isAuthenticated, user } = useAuth0();
  const sub = user?.sub;

  useEffect(() => {
    if (isLoading) return;
    setAnalyticsUser(isAuthenticated && sub ? sub : null);
  }, [isLoading, isAuthenticated, sub]);
};

export default useAnalyticsUser;
